export default class TicketInfo {
    constructor() { 
        this.dayOfMonth = 0
    }
}